import { useDotdigitalSubscribe } from "@src/hooks/useDotdigitalSubscribe";
import React from "react";

const SubscribeForm = ({ email, setEmail, subscribe, isMobile, settings}) => {
    const handleInputChange = (e) => setEmail(e.target.value);
    const { globals } = settings;

    // This will need to be a setting for all globals
    // TODO: Retrieve URL and Params, ensure global settings are craeted in react-props.liquid
    // dotdigital_api_url: 'https://r1-api.dotdigital.com/v2',
    // dotdigital_username: 'rhiannonp@mindarc.com.au',
    // dotdigital_password: 'test123',

    const dotdigitalRegion = 'r3'; // Asia pacific
    const dotdigitalUrl = `https://${dotdigitalRegion}-api.dotdigital.com/v2/`;

    // const { isLoading, error, success, subscribe: dotdigitalSubscribe } = useDotdigitalSubscribe(
    //     `${dotdigitalUrl}/contacts/with-consent-and-preferences`
    // );

    // This will need to be a setting
    const subscribeProvider: string = 'DOTDIGITAL';

    const handleSubscribe = () => {

        switch (subscribeProvider) {
            case 'DOTDIGITAL':
                console.log('Hitting Dotdigital subscribe');
                // dotdigitalSubscribe(email);
                break;
            case 'SHOPIFY':
                console.log('Hitting Shopify subscribe');
                if (email) subscribe(email);
                break;
            default:
                break;
        }
    };


    // This will need to be a setting
    const useEmbedForm = false; 
    const embedSrc = '//email.leemathews.com.au/resources/sharing/embed.js?sharing=lp-embed&domain=email.leemathews.com.au&id=7N8B-A43%2Fwebsite-footer%22';

    return (
        <>
            {useEmbedForm && <script src={`${embedSrc}`}></script>}
            
            {!useEmbedForm && <button className="buttomn text-black w-full mt-6 lg:mt-[32px] pill-input-button" style={{ height: "49px" }}>
                <div className="flex basis-auto flex-auto justify-between items-center">
                    <input
                        type="text"
                        className={`${isMobile ? "b3__semibold" : "b2__semibold"} justify-start placeholder-black`}
                        placeholder="ENTER YOUR EMAIL"
                        value={email}
                        onChange={handleInputChange}
                        aria-label="Email"
                        style={{ background: "none", border: "none", padding: 0, color: "black" }}
                    />
                
                    <div 
                        className={`${isMobile ? "b3" : "b2"} flex gap-x-[8px] justify-end items-center`} 
                        onClick={handleSubscribe}
                    >
                        <div className="font-normal max-lg:underline max-lg:text-sm" role="button" aria-label="Subscribe">
                            Subscribe
                        </div>
                        <div className="icon icon-ur-arrow text-[17px] lg:text-[19px]" />
                    </div>
                </div>
            </button>}
        </>
       
    );
};

export default SubscribeForm;
